import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { AftersalesOrder } from '@1po/1po-bff-fe-spec/generated/aftersales_order/model/AftersalesOrder';
import { ROUTER_ASC_ORDERS } from 'app/AppRouter';
import { getAscOrders } from 'domains/order/Order.store';
import AscOrderDetailInformation from 'pages/MyOrdersPage/AscOrders/AscOrderDetailInformation';
import AscOrderDetailTable from 'pages/MyOrdersPage/AscOrders/Tables/AscOrderDetailTable';
import ClaimFormModal from 'pages/MyOrdersPage/OrderClaims/ClaimFormModal';
import CreateMultiItemsClaimButton from 'pages/MyOrdersPage/OrderClaims/CreateMultiItemsClaimButton';
import { theme } from 'styles';
import { Flex, Text } from 'UI';
import { getSearchData } from 'utils';

export interface OrderDetailProps {
  orderDetail: AftersalesOrder;
  setIsOpenCreateClaim?: (value: boolean) => void;
}

const AscOrderDetail = () => {
  const { salesOrderNumber } = useParams<{ salesOrderNumber?: string }>();
  const { t } = useTranslation();
  const [isOpenCreateClaim, setIsOpenCreateClaim] = useState(false);
  const history = useHistory();
  const ascOrdersState = useSelector(getAscOrders);
  const ascOrdersData = getSearchData(ascOrdersState)?.orders ?? [];
  const orderDetail = ascOrdersData.find((ascOrder) => ascOrder.salesOrderNumber === salesOrderNumber);

  useEffect(() => {
    if (!orderDetail) {
      history.push(ROUTER_ASC_ORDERS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail]);

  if (!orderDetail) {
    return null;
  }

  return (
    <Flex background={theme.color.grey95} minHeight={'100%'} padding={50}>
      <ClaimFormModal isOpen={isOpenCreateClaim} setIsOpen={setIsOpenCreateClaim} />
      <Flex background={theme.color.white} direction={'column'} padding={30} gap={50} maxWidth={'100%'}>
        <Text type={'h1_banner_light'}>{t('asc_order.order_information', 'Order information')}</Text>
        <Flex size={0} align={'flex-end'}>
          <AscOrderDetailInformation orderDetail={orderDetail} />
          <Flex />
          <CreateMultiItemsClaimButton orderDetail={orderDetail} setIsOpen={setIsOpenCreateClaim} />
        </Flex>
        <AscOrderDetailTable orderDetail={orderDetail} setIsOpenCreateClaim={setIsOpenCreateClaim} />
      </Flex>
    </Flex>
  );
};

export default AscOrderDetail;
